
/** 
 * Simple wrapper for AbortController 
 * that do nothing when there's no AbortController
 * */
export default class AbortController {
   constructor() {
      this._abortController = ('AbortController' in window) ?
         new window.AbortController() : null;
   }

   abort() {
      if (!this._abortController) return;
      this._abortController.abort();
   }

   get signal() {
      return (this._abortController) ?
         this._abortController.signal : null;
   }
}